<template>
  <div class="p-group-post-create">
    <CommonHeader>
      <span class="post-title" />{{ $t('release.post') }}
      <span
        slot="right"
        :class="{ disabled }"
        class="primary"
        @click="onSubmit"
      >
        {{ $t('release.name') }}
      </span>
      <span
        slot="left"
        class="primary"
        @click="onCancel"
      >{{ $t('cancel') }}</span>
    </CommonHeader>

    <section
      v-if="!groupId"
      class="form-select-item"
      @click="selectGroup"
    >
      <label>选择圈子{{ group.name?'':'(必填)' }}</label>
      <div class="input-wrap">
        <span class="placeholder">{{ group.name }}</span>
        <svg class="m-style-svg m-svg-def m-entry-append">
          <use xlink:href="#icon-arrow-right" />
        </svg>
      </div>
    </section>

    <main class="content-main">
      <div class="title-wrap">
        <input
          v-model="title"
          type="text"
          placeholder="输入标题，50字以内（必填）"
          maxlength="50"
        >
      </div>
      <FormTagsItem
        v-model="tags"
        class="tags-select"
        :label="$t('tags.select')"
        placeholder=" "
        :max="10"
      />

      <div class="content-wrap">
        <div class="textarea-shadow">{{ content }}</div> <!-- 用于撑起文本框自适应高度 -->
        <textarea
          v-model="content"
          placeholder="输入要说的话，图文结合更精彩哦(必填)"
          :rows="5"
          :maxlength="20000"
        />
      </div>
      <div class="upload-img">
        <ImageList v-model="images" />
      </div>
    </main>

    <FormSwitchItem
      v-if="group.allow_feed"
      v-model="sync_feed"
      class="form-switch-item"
      label="同步至分享"
    />

    <ChooseGroup
      v-if="!groupId"
      ref="chooseGroup"
      :simple="true"
      :default-group="group"
      @change="onGroupChange"
    />
  </div>
</template>

<script>
  import ImageList from './components/ImageListWithModel'
  import ChooseGroup from './components/ChooseGroup.vue'

  export default {
    name: 'GroupPostCreate',
    components: {
      ImageList,
      ChooseGroup,
    },
    data () {
      return {
        title: '',
        content: '',
        group: {},
        sync_feed: false,
        inputShow: true,
        attachments: [],
        images: [],
        status: false,
        tags: [],
      }
    },
    computed: {
      groupId () {
        return this.$route.query.group
      },
      disabled () {
        if (!this.groupId && !this.group.id) return true
        return !this.title || !this.content
      },
    },
    mounted () {
      this.initGroup()
    },
    methods: {
      async onSubmit () {
        if (this.disabled) return
        const params = {
          groupId: this.groupId || this.group.id,
          title: this.title,
          body: this.content,
          sync_feed: ~~this.sync_feed,
          summary: this.content.substr(0, 144),
          tags: this.tags,
          // status: ~~this.status,
          images: this.images.map(item => item.id),
        }
        this.images.forEach(element => {
          params.body += `<img src="/api/v2/files/${element.id}">`
        })
        const data = await this.$store.dispatch('group/createPost', params)
        if (data) {
          this.$Message.success(data.message)
          this.$router.replace({
            name: 'groupPostDetail',
            params: { groupId: data.post.group_id, postId: data.post.id },
          })
        }
      },
      async initGroup () {
        // 从 store 中读取当前圈子信息
        if (!this.group.id && this.groupId) { this.group = this.$store.state.group.current }

        // 如果没有读到, 去远端拉取
        if (!this.group.id && this.groupId) {
          this.group = await this.$store.dispatch('group/getGroupById', {
            groupId: this.groupId,
          })
        }
      },

      selectGroup () {
        this.$refs.chooseGroup.show()
      },
      onGroupChange (group) {
        this.group = group
      },
      onCancel () {
        this.$router.back()
      },
      uploadAttachments () {
        if (!this.inputShow) {
          return this.$Message.error('上传中。。。')
        }
        this.$refs.imagefile.click()
      },
      async onBannerChange () {
        const $input = this.$refs.imagefile
        const file = $input.files[0]
        // 上传图片
        this.inputShow = false
        const id = await sendImage(file)
        this.inputShow = true
        this.attachments.push({ id, file })
      },
      deleteAttachments ({ id }) {
        this.attachments = this.attachments.filter(item => item.id !== id)
      },
      showRule () {
        this.$bus.$emit('popupDialog', {
          title: `${this.$t('question.reward.rule')}`,
          content: this.rule,
        })
      },
    },
  }
</script>

<style lang="less" scoped>
.p-group-post-create {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #fff;

  .disabled {
    color: #ccc;
  }

  .form-select-item {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 30px 0;
    margin: 0 30px;
    font-size: 30px;
    color:#1A1A1A;
    border-bottom: 1px solid @border-color; /* no */
    label {
      font-size: 30px;
    }
    .input-wrap {
      svg {
        vertical-align: middle;
      }
    }

    .placeholder {
      margin-right: 20px;
    }
  }

  > main {

    .title-wrap {
      padding-bottom: 30px;
      border-bottom: 2px solid @border-color;
    }

    .content-wrap {
      position: relative;
      width: 100%;
      height: calc(~"100% + 40px");
      padding-right: 20px;
      margin-top: 15px;

      .textarea-shadow {
        opacity: 0;
        min-height: 100px;
        padding: 28px 0;
        font-size: 14px;
        word-wrap: break-word;
        word-break: break-all;
      }

      textarea {
        position: absolute;
        top: 0;
        display: block;
        font-size: 30px;
        // padding: 28px 0;
        width: calc(~"100% - 20px");
        height: 100%;
        overflow: hidden;
        resize: none;
        outline: none;
        min-height: 200px;
        background-color: transparent;
        word-wrap: break-word;
        word-break: break-all;
      }
    }

    input,
    textarea {
      width: 100%;
      height: 100%;
      font-size: 30px;
      padding: 0;
    }
  }

  .form-switch-item {
    position: fixed;
    bottom: 0;
    padding: 0 30px;
    border-top: 1px solid @border-color; /* no */
  }
}
 .upload-img {
    text-align: left;
    width: 100%;
    margin-top: 100px;
    // position: absolute;
    // bottom: 0;
    // left: 0;
  }
  .uploader {
    border: 1px solid #dbdbdb;
    display: inline-block;
    height: 150px;
    width: 150px;
    padding-top: 50px;
    padding-left: 50px;
    margin: 0 auto;
  }
  .content-main {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    flex: auto;
    padding: 30px;
    padding-bottom:120px !important
  }
  .tags-select  {
    padding:  0;
    // margin: 0 30px;
  }
</style>
<style scoped>
.tags-select >>> label{
  color: #1a1a1a;
  font-size: 30px;
}
.tags-select  >>> .input-wrap {
  padding: 0 !important;
  /* justify-content:flex-start !important */
}
.primary {
  font-size: 32px;
}
.post-title {
  font-size: 36px;
}
.tags-select  >>>  .m-tags{
  flex-grow: 1;
  margin: 10px 0 10px 30px;
  text-align: left;
}
</style>
